import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 w-full bg-white/95 backdrop-blur-md shadow-[var(--shadow-elegant)] z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-10 h-10 bg-gradient-to-br from-primary to-primary-dark rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">BV</span>
            </div>
            <div className="flex flex-col">
              <span className="text-xl font-display font-bold text-secondary leading-none">
                Brussels VIP
              </span>
              <span className="text-xs text-gray-500 uppercase tracking-wider">Transport</span>
            </div>
          </Link>
          
          <nav className="hidden lg:flex items-center space-x-1">
            <Link to="/" className="px-4 py-2 text-gray-700 hover:text-primary transition-colors link-underline">
              Home
            </Link>
            <Link to="/services" className="px-4 py-2 text-gray-700 hover:text-primary transition-colors link-underline">
              Services
            </Link>
            <Link to="/fleet" className="px-4 py-2 text-gray-700 hover:text-primary transition-colors link-underline">
              Fleet
            </Link>
            <Link to="/pricing" className="px-4 py-2 text-gray-700 hover:text-primary transition-colors link-underline">
              Pricing
            </Link>
            <Link to="/about" className="px-4 py-2 text-gray-700 hover:text-primary transition-colors link-underline">
              About
            </Link>
            <Link to="/blog" className="px-4 py-2 text-gray-700 hover:text-primary transition-colors link-underline">
              Blog
            </Link>
            <Link 
              to="/reservation" 
              className="ml-4 btn-luxury py-2.5 px-6 text-sm"
            >
              Book Now
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button onClick={toggleMobileMenu} className="text-secondary focus:outline-none p-2">
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden fixed top-0 right-0 w-80 h-full bg-white shadow-2xl z-50 transform ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'} transition-transform duration-300 ease-in-out`}>
        <div className="p-6">
          <div className="flex justify-end mb-8">
            <button onClick={toggleMobileMenu} className="text-secondary focus:outline-none p-2">
              <X className="h-6 w-6" />
            </button>
          </div>
          <nav className="flex flex-col space-y-2">
            <Link to="/" className="text-secondary hover:text-primary block py-3 px-4 rounded-lg hover:bg-neutral-cream transition-colors font-medium" onClick={toggleMobileMenu}>
              Home
            </Link>
            <Link to="/services" className="text-secondary hover:text-primary block py-3 px-4 rounded-lg hover:bg-neutral-cream transition-colors font-medium" onClick={toggleMobileMenu}>
              Services
            </Link>
            <Link to="/fleet" className="text-secondary hover:text-primary block py-3 px-4 rounded-lg hover:bg-neutral-cream transition-colors font-medium" onClick={toggleMobileMenu}>
              Fleet
            </Link>
            <Link to="/pricing" className="text-secondary hover:text-primary block py-3 px-4 rounded-lg hover:bg-neutral-cream transition-colors font-medium" onClick={toggleMobileMenu}>
              Pricing
            </Link>
            <Link to="/about" className="text-secondary hover:text-primary block py-3 px-4 rounded-lg hover:bg-neutral-cream transition-colors font-medium" onClick={toggleMobileMenu}>
              About
            </Link>
            <Link to="/blog" className="text-secondary hover:text-primary block py-3 px-4 rounded-lg hover:bg-neutral-cream transition-colors font-medium" onClick={toggleMobileMenu}>
              Blog
            </Link>
            <Link to="/reservation" className="btn-luxury mt-4 text-center py-3" onClick={toggleMobileMenu}>
              Book Now
            </Link>
            <Link to="/auth" className="text-gray-600 hover:text-primary block py-2 px-4 text-sm text-center mt-4" onClick={toggleMobileMenu}>
              Login / Signup
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
